import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "body-systems",
  templateUrl: "body-systems.html",
})
export class BodySystemsComponent implements OnInit {
  @Input() categories: Array<string>;
  @Input() otherCategory: string;
  concatenedCategories: string;
  showMoreBodySystems = false;
  ngOnInit(): void {
    let tempCategories: Array<string> = this.categories
      ? this.categories.filter((category) => category.toLowerCase() !== "other")
      : [];
    if (this.otherCategory) {
      tempCategories.push(this.otherCategory);
    }
    this.concatenedCategories = tempCategories
      .map((category) => this.translatePipe.instant(category))
      .join(", ");
  }

  constructor(public translatePipe: TranslateService) {}

  trimString(string, length) {
    return string.length > length
      ? string.substring(0, length) + "..."
      : string;
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/medications/body-systems/body-systems.ts